// src/i18n/i18n.js
import { createI18n } from 'vue-i18n'

export const i18n = createI18n({
  legacy: false,
  locale: 'es', // idioma por defecto
  fallbackLocale: 'en',
  messages: {}, // VACÍO al inicio (esto es lazy load)
  globalInjection: true
})

/**
 * Carga dinámicamente el archivo de idioma
 * @param {string} locale - código del idioma (ej: 'es', 'en')
 */
export async function loadLocale(locale) {
  // Verifica si ya está cargado (evita cargar dos veces)
  if (i18n.global.availableLocales.includes(locale)) {
    i18n.global.locale.value = locale
    localStorage.setItem('locale', locale)
    return
  }

  try {
    // Importa dinámicamente el JSON del idioma
    const messages = await import(`./locales/${locale}.json`)

    // Registra los mensajes en la instancia de i18n
    i18n.global.setLocaleMessage(locale, messages.default)

    // Cambia el idioma activo
    i18n.global.locale.value = locale

    // Persiste en localStorage
    localStorage.setItem('locale', locale)
  } catch (error) {
    console.error(`Error cargando idioma '${locale}':`, error)
    i18n.global.locale.value = 'en' // fallback
  }
}
